//authentication
export const AUTHENTICATION_ACTION_DUMMY_EVENT =
  "AUTHENTICATION_ACTION_DUMMY_EVENT";

//ticket
export const TICKET_ADD_PAIR = "TICKET_ADD_PAIR";
export const TICKET_REMOVE_PAIR = "TICKET_REMOVE_PAIR";
export const TICKET_CHANGE_PAIR_CHECKED_STATE =
  "TICKET_CHANGE_PAIR_CHECKED_STATE";
export const TICKET_SELECT_ALL_PAIRS = "TICKET_SELECT_ALL_PAIRS";
export const TICKET_DESELECT_ALL_PAIRS = "TICKET_DESELECT_ALL_PAIRS";
export const TICKET_REMOVE_ALL_PAIRS = "TICKET_REMOVE_ALL_PAIRS";
export const TICKET_RESTORE_STATE_FROM_LOCALSTORAGE =
  "TICKET_RESTORE_STATE_FROM_LOCALSTORAGE";
export const TICKET_PAIRS_UPDATE_COEFS = "TICKET_PAIRS_UPDATE_COEFS";
export const TICKET_SET_BET_AMOUNT = "TICKET_SET_BET_AMOUNT";
export const TICKET_SET_COMBINATION_BET_AMOUNT =
  "TICKET_SET_COMBINATION_BET_AMOUNT";
export const TICKET_SET_TICKET_TYPE = "TICKET_SET_TICKET_TYPE";
export const TICKET_TOGGLE_PAIR_FIX_STATE = "TICKET_TOGGLE_PAIR_FIX_STATE";
export const TICKET_TOGGLE_ACTIVE_SYSTEM = "TICKET_TOGGLE_ACTIVE_SYSTEM";
export const TICKET_SET_EDITED_COMBINATION_ID =
  "TICKET_SET_EDITED_COMBINATION_ID";

//sport event
export const SPORT_EVENT_SET_LIVE_INITIAL_SET =
  "SPORT_EVENT_SET_LIVE_INITIAL_SET";
export const SPORT_EVENT_SET_LIVE_THIRD_PARTITION_SET =
  "SPORT_EVENT_SET_LIVE_THIRD_PARTITION_SET";
export const SPORT_EVENT_SET_PREMATCH_PICKER_ITEMS =
  "SPORT_EVENT_SET_PREMATCH_PICKER_ITEMS";
export const SPORT_EVENT_SET_PREMATCH_LEAGUE_INFO =
  "SPORT_EVENT_SET_PREMATCH_LEAGUE_INFO";
export const SPORT_EVENT_SET_PREMATCH_CATEGORIES_INFO =
  "SPORT_EVENT_SET_PREMATCH_CATEGORIES_INFO";
export const SPORT_EVENT_SET_ALL_BETS_TEXT = "SPORT_EVENT_SET_ALL_BETS_TEXT";

//navigation
export const NAVIGATION_CHANGE_CURRENT_ADMIN_SCREEN =
  "NAVIGATION_CHANGE_CURRENT_ADMIN_SCREEN";
export const NAVIGATION_CHANGE_SPORT_PREMATCH =
  "NAVIGATION_CHANGE_SPORT_PREMATCH";
export const NAVIGATION_CHANGE_SPORT_LIVE = "NAVIGATION_CHANGE_SPORT_LIVE";
export const NAVIGATION_CHANGE_CALENDAR_ITEM =
  "NAVIGATION_CHANGE_CALENDAR_ITEM";
export const NAVIGATION_CHANGE_MOST_PLAYED_BUTTON =
  "NAVIGATION_CHANGE_MOST_PLAYED_BUTTON";
export const NAVIGATION_CHANGE_COUNTRY = "NAVIGATION_CHANGE_COUNTRY";
export const NAVIGATION_CHANGE_LEAGUE = "NAVIGATION_CHANGE_LEAGUE";
export const NAVIGATION_CHANGE_CURRENT_LIVE_EXTRA_BETS_ID =
  "NAVIGATION_CHANGE_CURRENT_LIVE_EXTRA_BETS_ID";
export const NAVIGATION_CHANGE_CURRENT_PREMATCH_EXTRA_BETS_ID =
  "NAVIGATION_CHANGE_CURRENT_PREMATCH_EXTRA_BETS_ID";
export const NAVIGATION_CHANGE_CURRENT_BET_GROUPS =
  "NAVIGATION_CHANGE_CURRENT_BET_GROUPS";
export const NAVIGATION_SET_SHOULD_QUICK_CLOSE_EXTRA_BETS =
  "NAVIGATION_SET_SHOULD_QUICK_CLOSE_EXTRA_BETS";
export const NAVIGATION_SET_TICKET_FOR_DETAILS =
  "NAVIGATION_SET_TICKET_FOR_DETAILS";
export const NAVIGATION_SET_PAYOUT_RECEIPT_NUMBER_FOR_DETAILS =
  "NAVIGATION_SET_PAYOUT_RECEIPT_NUMBER_FOR_DETAILS";
export const NAVIGATION_SET_CAN_SHOW_EXTRA_BETS_LIVE =
  "NAVIGATION_SET_CAN_SHOW_EXTRA_BETS_LIVE";
export const NAVIGATION_SET_CAN_SHOW_EXTRA_BETS_PREMATCH =
  "NAVIGATION_SET_CAN_SHOW_EXTRA_BETS_PREMATCH";
export const NAVIGATION_SET_TERMINAL_ACTIONS_ACTIVE_BUTTON =
  "NAVIGATION_SET_TERMINAL_ACTIONS_ACTIVE_BUTTON";
export const NAVIGATION_SET_IS_SHOWING_BONUS_INFO =
  "NAVIGATION_SET_IS_SHOWING_BONUS_INFO";
export const NAVIGATION_SET_IS_SHOWING_SYSTEM_INFO =
  "NAVIGATION_SET_IS_SHOWING_SYSTEM_INFO";
export const NAVIGATION_CHANGE_ADMIN_LOGIN_STATE =
  "NAVIGATION_CHANGE_ADMIN_LOGIN_STATE";
export const NAVIGATION_CHANGE_ADMIN_LOADING_INDICATOR =
  "NAVIGATION_CHANGE_ADMIN_LOADING_INDICATOR";
export const NAVIGATION_CHANGE_LAST_USED_PICKER =
  "NAVIGATION_CHANGE_LAST_USED_PICKER";
export const NAVIGATION_SET_MATCH_FOR_STATISTICS_ID =
  "NAVIGATION_SET_MATCH_FOR_STATISTICS_ID";
export const NAVIGATION_SET_ADMIN_INFO = "NAVIGATION_SET_ADMIN_INFO";

//balance
export const BALANCE_UPDATE = "BALANCE_UPDATE";
export const BALANCE_ADD_FUNDS = "BALANCE_ADD_FUNDS";

//appstate
export const APPSTATE_START_LOADING = "APPSTATE_START_LOADING";
export const APPSTATE_STOP_LOADING = "APPSTATE_STOP_LOADING";
export const APPSTATE_SERVER_CHANGE_STATUS = "APPSTATE_SERVER_CHANGE_STATUS";
export const APPSTATE_CHANGE_CURRENT_LIVE_THEME =
  "APPSTATE_CHANGE_CURRENT_LIVE_THEME";
export const APPSTATE_SET_LANGUAGE = "APPSTATE_SET_LANGUAGE";
export const APPSTATE_SHOWS_LANGUAGE_PICKER = "APPSTATE_SHOWS_LANGUAGE_PICKER";
export const APPSTATE_SHOWS_SETTINGS_PICKER = "APPSTATE_SHOWS_SETTINGS_PICKER";
export const APPSTATE_SET_ODD_FORMAT = "APPSTATE_SET_ODD_FORMAT";
export const APPSTATE_SET_SORT_TYPE = "APPSTATE_SET_SORT_TYPE";
export const APPSTATE_SET_PRINTER_STATUSES = "APPSTATE_SET_PRINTER_STATUSES";
export const APPSTATE_SHOWS_NUMERIC_KEYBOARD =
  "APPSTATE_SHOWS_NUMERIC_KEYBOARD";
export const APPSTATE_SET_TAPE_BILL_INFO = "APPSTATE_SET_TAPE_BILL_INFO";
export const APPSTATE_SET_MACHINE_INFO = "APPSTATE_SET_MACHINE_INFO";
export const APPSTATE_SET_NEW_ROLL_LENGTH = "APPSTATE_SET_NEW_ROLL_LENGTH";



// WEBPACK FOOTER //
// ./src/ReduxStore/Actions/ActionTypes.js